import { BASE_URL, FEATURE_SETTINGS_ENDPOINT, SOMS_API_KEY } from "services/CONSTANTS";
import { ADD_MAX_CAP_FAILURE, ADD_MAX_CAP_REQUEST, ADD_MAX_CAP_RESET, ADD_MAX_CAP_SUCCESS } from "./action-type";
import { Post } from "services/apiService";

export const addMaxCapAction = (payload) => {
    return (dispatch) => {
        dispatch(addMaxCapRequest());
        const apiUrl = `${BASE_URL}${FEATURE_SETTINGS_ENDPOINT}?apikey=${SOMS_API_KEY}`;
        const request = {
            url: apiUrl,
            params: payload,
        };
        Post(request)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(addMaxCapSuccess(response));
                } else {
                    dispatch(addMaxCapFailure(response));
                }
            })
            .catch((err) => {
                dispatch(addMaxCapFailure(err));
            });
    };
};

const addMaxCapRequest = () => ({
    type: ADD_MAX_CAP_REQUEST,
});

const addMaxCapSuccess = (response) => ({
    type: ADD_MAX_CAP_SUCCESS,
    addMaxCapResponse: response,
});

const addMaxCapFailure = (error) => ({
    type: ADD_MAX_CAP_FAILURE,
    addMaxCapResponse: error,
});

export const addMaxCapReset = () => ({
    type: ADD_MAX_CAP_RESET,
});
